export interface Message {
  type: MessageType;
  action: MessageAction;
  payload: any;
  subscription_id?: string;
}

export enum MessageType {
  SIGNIN = 'SIGNIN',
  HEARTBEAT = 'HEARTBEAT',
  WALLET = 'WALLET',
  MINING = 'MINING',
  ANALYTICS = 'ANALYTICS',
  YETI = 'YETI',
  TASK_COMPLETE = 'TASK_COMPLETE',
  SCREENTIME = 'SCREENTIME',
}

export enum MessageAction {
  // Request
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
  EXECUTE = 'EXECUTE',

  // Response
  STATUS = 'STATUS',
  NOTIFICATION = 'NOTIFICATION',
}

export type CbType = (data: Message) => any;
